import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Search } from 'components/SearchBar/components';
import { useSelector } from 'react-redux';
import {
  Modal,
  Card,
  CardContent,
  CardActions,
  Button,
  CardHeader,
  Divider,
  TableHead,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Grid,
  Box
} from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import theme from 'theme';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 850,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  content: {
    padding: 0
  },
  actions: {
    justifyContent: 'flex-end'
  },
  progress: {
    marginBottom: theme.spacing(2)
  },
  fileName: {
    marginBottom: theme.spacing(2)
  },
  image: {
    width: '100%'
  },
  details: {
    padding: theme.spacing(2)
  },
  comment: {
    flexGrow: 1,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    borderColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: 1,
    position: 'relative',
    marginTop: theme.spacing(1)
  },
  search: {
    minWidth: 480,
    maxWidth: 480,
    flexBasis: 480
  },
  tableContainer: {
    minHeight: 450,
    maxHeight: 450,
    overflowY: 'auto'
  },
  searchContainer: {
    padding: theme.spacing(2)
  },
  selfSearch: {
    marginTop: 3
  },
  buttonCell: {
    paddingTop: 0,
    paddingBottom: 0
  },
  buttonExtraSmall: {
    padding: '1px 8px',
    fontSize: '0.8125rem'
  },
  actionsColumn: {
    width: 100
  }
}));

const VenueSelect = props => {
  const {
    open,
    onClose,
    venues,
    onSelectVenue,
    onRefreshVenues,
    className,
    ...rest
  } = props;

  const classes = useStyles();

  const loading = false;
  const [searchName, setSearchName] = useState('');
  const { sessionUser } = useSelector(state => state.session);

  const findVenuesByName = searchName => {
    return venues.filter(venue => {
      return (
        searchName === '' ||
        venue.name.toUpperCase().indexOf(searchName.toUpperCase()) !== -1
      );
    });
  };

  const findFirstVenueByName = searchName => {
    const venues = findVenuesByName(searchName);
    return venues.length > 0 ? venues[0] : null;
  };

  const searchedVenues = findVenuesByName(searchName);

  const handleClose = () => {
    onClose();
  };

  const handleSearchFieldChange = value => {
    setSearchName(value);
  };

  if (!open) {
    return null;
  }

  return (
    <Modal onClose={handleClose} open={open}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <CardHeader title="Select Venue" />
        <Divider />

        <CardContent className={classes.content}>
          <div className={classes.searchContainer}>
            <Grid container spacing={3}>
              <Grid item>
                <Box display="flex" alignItems="center">
                  <Search
                    placeholder="Name"
                    value={searchName}
                    onSearchValueChange={handleSearchFieldChange}
                    className={classes.search}
                    hideSearchButton={true}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    // disabled={saving || !customerEvent.customer?.id}
                    // variant="outlined"
                    onClick={onRefreshVenues}
                    style={{ marginLeft: theme.spacing(3), height: 36 }}>
                    <RefreshIcon />
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() =>
                      window.open('/reference/venues/create', '_blank')
                    }
                    style={{ marginLeft: theme.spacing(1), height: 36 }}>
                    Create New...
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </div>
          <Divider />
          <div className={classes.tableContainer}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.actionsColumn}>
                    Actions
                  </TableCell>
                  <TableCell>Venue</TableCell>
                  <TableCell>Customer</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchedVenues.map(venue => (
                  <TableRow key={venue.id} hover>
                    <TableCell className={classes.buttonCell}>
                      <Button
                        className={classes.buttonExtraSmall}
                        color="primary"
                        size="small"
                        variant="outlined"
                        onClick={() => onSelectVenue(venue)}>
                        Select
                      </Button>
                    </TableCell>
                    <TableCell>{venue.name}</TableCell>
                    <TableCell>{venue.customer.customerName}</TableCell>
                  </TableRow>
                ))}
                {!loading && searchedVenues.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3}>No data available</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <Button onClick={handleClose} variant="contained">
            Done
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};

VenueSelect.displayName = 'VenueSelect';

VenueSelect.propTypes = {
  className: PropTypes.string
};

export default VenueSelect;
